export default [
    {
        text: 'Código interno',
        value: 'internal_code',
    },
    {
        text: 'producto',
        value: 'name',
    },
    {
        text: 'alias',
        value: 'alias_name',
    },
    {
        text: 'subfamilia',
        fieldType: 'computed',
        computed: ({ wh_subfamily }) => wh_subfamily.subfamily,
    },
]
